const state = {
  language: 'pt', // Default language
  availableLanguages: ['pt', 'en', 'es', 'zh'],
  showSettingsModal: false // Modal visibility state
}

const getters = {
  currentLanguage: state => state.language,
  availableLanguages: state => state.availableLanguages,
  isSettingsModalVisible: state => state.showSettingsModal
}

const mutations = {
  SET_LANGUAGE(state, language) {
    state.language = language
  },
  TOGGLE_SETTINGS_MODAL(state, value) {
    state.showSettingsModal = value !== undefined ? value : !state.showSettingsModal
  }
}

const actions = {
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
    localStorage.setItem('userLanguage', language)
  },
  toggleSettingsModal({ commit }, value) {
    commit('TOGGLE_SETTINGS_MODAL', value)
  },
  initializeConfig({ commit }) {
    // Load saved language from localStorage if available
    const savedLanguage = localStorage.getItem('userLanguage')
    if (savedLanguage) {
      commit('SET_LANGUAGE', savedLanguage)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
